module.exports = __webpack_public_path__ + "static/img/GU@3x.99a4932e.jpg";